export function PlusIcon() {
    return (
        <svg viewBox="0 0 250 250" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M225 125H125M125 125H25M125 125V25M125 125V225" stroke="#1C274C" strokeWidth="50" strokeLinecap="round"/>
        </svg>
    );
}